<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>>  -->
        <v-btn fab small @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<<  -->


		<v-toolbar-title class="hidden-sm-and-down">People</v-toolbar-title>


		<!-- >>> Filter TextField -->
		<v-text-field style="margin-left: 60px; margin-top:22px;"
			v-model="filterTerm"
			label=" Filter Resources"
			@keyup="onKeyup_filterResources">
		</v-text-field>
		<!-- <<< Filter TextField -->


		<span style="margin-left: 30px; margin-top: 31px;"><strong>Shown Resources: {{ get_Resources_Filtered.length }}</strong></span>


		<v-spacer></v-spacer>


		<!-- >>> Sdr-Component, Filter Menue -->
		<sdr-people-appbar-filtermenue style="margin-left: 40px;"></sdr-people-appbar-filtermenue>
		<!-- <<< Sdr-Component, Filter Menue -->



        <!-- >>> Reset: 'Download Report' ---------------------------------- -->
        <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="#ffffff" v-bind="attrs" v-on="on" depressed elevation="1" class="mt-1" min-width="0" style="margin-left: 40px; margin-right: 20px;" @click="onClick_DownloadPeopleReport">
                    <v-icon style="top: 3px; color: #000000 !important;">
                        mdi-arrow-down-thin-circle-outline
                    </v-icon>
                </v-btn>
            </template>
            <span>
                Download
            </span>
        </v-tooltip>
        <!-- <<< Reset: 'Download Report' ---------------------------------- -->



        <!-- >>> Reset: 'Reset Calendar' ----------------------------------- -->
        <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="#ab2b7a" v-bind="attrs" v-on="on" depressed elevation="1" class="mt-1" min-width="0" style="margin-left: 80px; margin-right: 20px;" @click="onClick_CalendarRefresh">
                    <v-icon style="top: 3px; color: #ffffff !important;">
                        mdi-refresh
                    </v-icon>
                </v-btn>
            </template>
            <span>
                Refresh
            </span>
        </v-tooltip>
        <!-- <<< Reset: 'Reset Calendar' ----------------------------------- -->
	</v-app-bar>
</template>

<script>
	import FilterMenue from './FilterMenue.vue';
	import { mapActions, mapGetters } from 'vuex';


	export default {
		name: 'PeopleAppBar',

		/* >>> *************************************************************** / /* Components */
		components: {

			'sdr-people-appbar-filtermenue': FilterMenue,

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: () => ({

			switchCabin: true,
			switchCockpit: true,
			// >>> ------------------------------
			filterTerm: ''

		}), // eo data()
		/* <<< ****************************************************************/




		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Resources_Filtered',
				'get_Shared_AuthHeader'
			])

		}, // eo computed{}
		/* <<< ****************************************************************/




		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_set_filterResources_filterTerm',
				'actn_call_getResourcesOfDepartment',
				'actn_call_download_PeopleReport'
			]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
            * onKeyup_filterResources()
            *
            * Desc:
            * Note:
            *
            */
			onKeyup_filterResources: function() {

				let me = this;


				me.$toc('>>> views/people/components/core/AppBar.vue >>> onKeyup_filterResources');
				this.actn_set_filterResources_filterTerm(this.filterTerm);

			}, // eo function onKeyup_filterResources()


            /*******************************************************************
			* onClick_CalendarRefresh()
			*
			* Desc: Emit
            * Note:
            *
			*/
            onClick_CalendarRefresh: function(value) {

				this.actn_call_getResourcesOfDepartment({ department: '12', secondLoad: false });
				this.actn_call_getResourcesOfDepartment({ department: '11', secondLoad: true });

            }, // eo function onClick_CalendarRefresh()


            /*******************************************************************
			* onClick_DownloadPeopleReport()
			*
			* Desc: Emit
            * Note:
            *
			*/
            onClick_DownloadPeopleReport: function() {

				let me = this;


				me.$toc('>>> views/people/components/core/AppBar.vue >>> onClick_DownloadPeopleReport');
				this.actn_call_download_PeopleReport({ authheader: this.get_Shared_AuthHeader });


            }, // eo function onClick_DownloadPeopleReport()

		} // eo methods{}
		/* <<< ****************************************************************/
	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }
</style>
